import { Tooltip } from "primereact/tooltip";
import { useContext, useEffect, useRef } from "react";
import AppMenuitem from "./AppMenuitem";
import { LayoutContext } from "./context/layoutcontext";
import { MenuProvider } from "./context/menucontext";

const AppSubMenu = (props) => {
    const { layoutState } = useContext(LayoutContext);
    const tooltipRef = useRef(null);

    useEffect(() => {
        if (tooltipRef.current) {
            tooltipRef.current.hide();
            tooltipRef.current.updateTargetEvents();
        }
    }, [layoutState.overlaySubmenuActive]);

    return (
        <MenuProvider>
            <ul className="layout-menu">
                {props.model.map((item, i) => {
                    return !item.seperator ? <AppMenuitem item={item} root index={i} key={item.label} /> : <li className="menu-separator" />;
                })}
            </ul>
            <Tooltip ref={tooltipRef} target="li:not(.active-menuitem)>.tooltip-target" />
        </MenuProvider>
    );
};

export default AppSubMenu;
